import { Link } from "react-router-dom";
import "./footer.css";

const Footer = () => (
  <footer className="apn-footer-modern" style={{width:'100%',margin:0}}>
    <div className="apn-footer-container" style={{width:'100%',margin:0}}>
      <div className="apn-footer-grid">
        {/* Marke */}
        <div className="apn-footer-brand">
          <div className="apn-footer-logo-group">
            {/* Logo-Datei in /public ablegen */}
            <img src="/apn-logo.png" alt="AP-Network Logo" className="apn-footer-logo" />
            <h3 className="apn-footer-title">AP-Network</h3>
          </div>
          <p className="apn-footer-desc">
            Das Webportal von AP-Network.<br />
            Vernetzen, zusammenarbeiten und wachsen.
          </p>
        </div>

        {/* Navigation (interne Links als SPA-Links) */}
        <div className="apn-footer-nav">
          <h4 className="apn-footer-heading">Navigation</h4>
          <div className="apn-footer-nav-links">
            <Link to="/">Startseite</Link>
            {/* <Link to="/dashboard">Mitgliederbereich</Link> */}
            <Link to="/kontakt">Kontakt</Link>
            <Link to="/agb">AGB</Link>
            <Link to="/datenschutz">Datenschutz</Link>
            <Link to="/impressum">Impressum</Link>
          </div>
        </div>

        {/* Community / Social (extern) */}
        <div className="apn-footer-community">
          <h4 className="apn-footer-heading">Netzwerk</h4>
          <p className="apn-footer-desc">Folge uns auf unseren Kanälen.</p>
          <div className="apn-footer-social" aria-label="AP-Network Social Links">
            {/* Twitch */}
            <a href="https://www.twitch.tv/apn_official" target="_blank" rel="noopener noreferrer" aria-label="Twitch" className="is-twitch">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M4 3h16v10.5l-4 4H12l-2.5 2.5H7.5V17H4V3zm14 9V5H6v10h3v2l2-2h4l3-3z"></path>
                <rect x="13" y="7" width="2" height="5"></rect>
                <rect x="9" y="7" width="2" height="5"></rect>
              </svg>
            </a>
            {/* TikTok */}
            <a href="https://www.tiktok.com/@user28578683368075?lang=de-DE" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="is-tiktok">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M14.5 3c.6 2.2 2.2 4 4.4 4.6v3.1c-1.6-.1-3.1-.6-4.4-1.5v5.7c0 3.6-2.9 6.6-6.5 6.6S1.5 18.5 1.5 14.9 4.4 8.3 8 8.3c.6 0 1.2.1 1.8.3v3.3c-.5-.3-1.1-.5-1.8-.5-1.8 0-3.3 1.5-3.3 3.5s1.5 3.5 3.3 3.5 3.3-1.5 3.3-3.5V3h3.9z"></path>
              </svg>
            </a>
            {/* YouTube */}
            <a href="https://www.youtube.com/@AP-Network_official" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="is-youtube">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M23 7.1s-.2-1.6-.8-2.3c-.7-.8-1.5-.8-1.9-.9-2.7-.2-6.8-.2-6.8-.2h-.1s-4.1 0-6.8.2c-.4 0-1.2.1-1.9.9C2.2 5.5 2 7.1 2 7.1S1.8 8.9 1.8 10.8v1.7C1.8 14.4 2 16.2 2 16.2s.2 1.6.8 2.3c.7.8 1.6.8 2 1 1.4.1 6 .2 6 .2s4.1 0 6.8-.2c.4 0 1.2-.1 1.9-.9.6-.7.8-2.3.8-2.3s.2-1.8.2-3.7v-1.7c0-1.9-.2-3.7-.2-3.7zM9.8 14.6V7.9l6.4 3.3-6.4 3.4z"></path>
              </svg>
            </a>
            {/* Kick */}
            <a href="https://kick.com/apn-official" target="_blank" rel="noopener noreferrer" aria-label="Kick" className="is-kick">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M3 3h18v18H3V3zm4 4v10h2.5V13l3 4h3.5l-3.6-4.2L16 7h-3.4l-3.1 4V7H7z"></path>
              </svg>
            </a>
            {/* Instagram */}
            <a href="https://www.instagram.com/ap_network_official/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="is-instagram">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12 2.2c3.2 0 3.6 0 4.8.1 1.2.1 1.9.3 2.6.7.7.4 1.2.9 1.6 1.6.4.7.6 1.4.7 2.6.1 1.2.1 1.6.1 4.8s0 3.6-.1 4.8c-.1 1.2-.3 1.9-.7 2.6-.4.7-.9 1.2-1.6 1.6-.7.4-1.4.6-2.6.7-1.2.1-1.6.1-4.8.1s-3.6 0-4.8-.1c-1.2-.1-1.9-.3-2.6-.7a4 4 0 0 1-1.6-1.6c-.4-.7-.6-1.4-.7-2.6C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.8c.1-1.2.3-1.9.7-2.6.4-.7.9-1.2 1.6-1.6.7-.4 1.4-.6 2.6-.7C8.4 2.2 8.8 2.2 12 2.2zm0 1.8c-3.1 0-3.4 0-4.6.1-1 .1-1.6.3-2 .5-.5.2-.8.5-1 .9-.3.4-.4 1-.5 2-.1 1.2-.1 1.5-.1 4.6s0 3.4.1 4.6c.1 1 .3 1.6.5 2 .2.5.5.8 1 .9.4.3 1 .4 2 .5 1.2.1 1.5.1 4.6.1s3.4 0 4.6-.1c1-.1 1.6-.3 2-.5.5-.2.8-.5 1-.9.3-.4.4-1 .5-2 .1-1.2.1-1.5.1-4.6s0-3.4-.1-4.6c-.1-1-.3-1.6-.5-2-.2-.5-.5-.8-1-.9-.4-.3-1-.4-2-.5-1.2-.1-1.5-.1-4.6-.1zm0 2.8a6.2 6.2 0 1 1 0 12.4 6.2 6.2 0 0 1 0-12.4zm0 2a4.2 4.2 0 1 0 0 8.4 4.2 4.2 0 0 0 0-8.4zm5-2.4a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8z"></path>
              </svg>
            </a>
            {/* Facebook */}
            <a href="https://www.facebook.com/profile.php?id=61584196058606" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="is-facebook">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M22 12.07C22 6.48 17.52 2 11.93 2 6.35 2 1.86 6.48 1.86 12.07c0 4.98 3.63 9.11 8.38 9.93v-7.02H7.9v-2.91h2.34V9.41c0-2.31 1.38-3.58 3.49-3.58.99 0 2.03.18 2.03.18v2.24h-1.15c-1.14 0-1.49.71-1.49 1.44v1.73h2.54l-.41 2.91h-2.13V22c4.75-.82 8.38-4.95 8.38-9.93z"></path>
              </svg>
            </a>
            {/* Discord */}
            <a href="https://discord.gg/PF5TrDbSaR" target="_blank" rel="noopener noreferrer" aria-label="Discord" className="is-discord">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M20.3 4.4A18 18 0 0 0 15.9 3l-.4.7c1.9.5 2.9 1.2 3.9 2.1-1.7-.9-3.3-1.4-4.9-1.6a17.9 17.9 0 0 0-6 0C6.9 4.4 5.3 5 3.6 5.8c1-.9 2-1.6 3.9-2.1L7.1 3a18 18 0 0 0-4.4 1.4C.8 7.7 0 11 .2 14.2c1.9 1.4 3.8 2.3 5.6 2.9l1-.7c-.6-.2-1.2-.6-1.8-1.1.3.1.7.3 1 .4 2 .8 4 .8 6 0 .4-.1.7-.3 1-.4-.6.5-1.2.9-1.8 1.1l1 .7c1.8-.6 3.7-1.5 5.6-2.9.2-3.2-.6-6.5-2.5-9.8zM9.2 13.8c-.9 0-1.6-.8-1.6-1.7s.7-1.7 1.6-1.7c.9 0 1.6.8 1.6 1.7s-.7 1.7-1.6 1.7zm5.6 0c-.9 0-1.6-.8-1.6-1.7s.7-1.7 1.6-1.7c.9 0 1.6.8 1.6 1.7s-.7 1.7-1.6 1.7z"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>

      <div className="apn-footer-bottom">
        <p>&copy; {new Date().getFullYear()} AP-Network. Alle Rechte vorbehalten.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
